import React, {useCallback} from 'react'
import './FormErrors.scss'

export default function FormErrors({errors}) {

	const box = useCallback(node => {
		if(node !== null) {
			node.focus()
		}
	},[])

	return(
		<div className="FormErrors" ref={box} aria-live="polite">
			<h2>Feil i skjemaet</h2>
			<ul>
				{
					Object.keys(errors).map(key =>
						<li aria-labelledby={key} key={key}>
							<a href={`#${key}`}>{errors[key].message}</a>
						</li>
					)
				}
			</ul>
		</div>
	)
}